import { IonCol, IonRouterOutlet, IonRow } from '@ionic/react';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { authenticationHelper } from '../../helpers';
import { ConversationPage, DashboardPage } from '../../pages';
import { ConversationRedirect } from '../expert/ConversationRedirect';
import { ExpertSidebar } from '../expert/ExpertSidebar';
import './expertLayout.scss';

export const ExpertLayout = () => {
  if (!authenticationHelper.isAuthenticated()) {
    return <Redirect to="/login" />;
  }

  return (
    <IonRow className="expert-layout">
      <IonCol size="3" className="expert-sidebar">
        <ExpertSidebar />
      </IonCol>
      <IonCol size="9">
        <IonRouterOutlet>
          <Switch>
            <Route
              path="/expert/conversation/:idExpert/:idCustomer"
              component={ConversationPage}
            />
            <Route
              exact
              path="/expert/conversation/:id"
              component={ConversationRedirect}
            />
            <Route path="/expert/dashboard" component={DashboardPage} />
            <Redirect from="/expert" to="/expert/dashboard" />
          </Switch>
        </IonRouterOutlet>
      </IonCol>
    </IonRow>
  );
};
